// ** Third Party Imports
import styled from 'styled-components'

// ** Utility Imports
import { media, zIndex } from '@/shared/styles'
import { IconButton } from '@/shared/ui'

export const NavbarWrapper = styled.div<{ $isNotHome?: boolean }>`
	${(props) =>
		props.$isNotHome &&
		`
	background-image: url('/images/main-section-bg.png');
	background-size: cover;
	background-position: top;
`}
`

export const InnerWrapper = styled.div<{ $isNotHome?: boolean }>`
	z-index: ${zIndex.navbar};
	margin: 0 auto;
	max-width: 74rem;
	display: flex;
	justify-content: space-between;
	padding-top: 1.5rem;
	align-items: center;

	${(props) => props.$isNotHome && `padding-bottom: 1.5rem;`}

	${media.xl} {
		max-width: 64rem;
	}

	${media.lg} {
		max-width: 48rem;
	}

	${media.md} {
		max-width: 34rem;
	}

	${media.sm} {
		max-width: 25rem;
	}

	${media.xs} {
		max-width: 21rem;

		.logo {
			width: 9rem;
			height: 3rem;
		}
	}

	.login-button {
		color: #141a3a;
	}
`

export const LinksGroup = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	column-gap: 3.5rem;

	& .link {
		text-decoration: none;
		font-family: 'Fustat', sans-serif;
		font-optical-sizing: auto;
		font-weight: 500;
		font-style: normal;
		font-size: 1.05rem;
		color: #fff;
		cursor: pointer;
	}

	.login-button {
		color: #141a3a;
	}
`

export const StyledSpan = styled.span``

export const MenuIcon = styled(IconButton)`
	& svg {
		& path {
			stroke: ${({ theme }) => theme.pallette.geniiWhite};
		}
	}
`

export const MobileMenu = styled.div<{ $isOpen: boolean }>`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 1000;
	background-color: #f5f5f5;
	display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
`

export const MobileMenuHeader = styled.div`
	display: flex;
	justify-content: flex-start;
	padding: 1rem;
`

export const MobileMenuLinks = styled.div`
	display: flex;
	flex-direction: column;
	padding: 1rem 0;
`

export const MobileMenuLink = styled.div`
	padding: 1rem 1.5rem;
	color: #000;
	text-decoration: none;
	font-size: 1.5rem;
	font-weight: 500;
	cursor: pointer;
`
